/* eslint-disable no-unused-expressions, no-magic-numbers, no-undef, curly */


const state = {
    isDownloading: false
};

const options = {

};

class Downloads {

    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        this._options = { ...Downloads.options, ...options };
        this._element = element;
        this._state = state;
        this._cacheSelectors();
        this._addListeners();
        this._openDownloads = this._openDownloads.bind(this);
        this._closeDownloads = this._closeDownloads.bind(this);
    }


    /**
     * Cache selectors
     *
     * @private
     */
    _cacheSelectors() {
        this._elements = {
            links: [...this._element.querySelectorAll('.downloads__list a')],
            closeButton: this._element.querySelector('[data-close-downloads]'),
            modalCloseButton: this._element.closest('.modal') && this._element.closest('.modal').querySelector('[data-close-modal]'),
            body: document.body,
            statusLink: this._element.querySelector('[data-download-link]')
        };
    }


    /**
     * Add listeners
     *
     * @private
     */
    _addListeners() {
        this._elements.links.forEach(link => {
            link.addEventListener('click', event => this._openDownloads(event), false);
        });
        this._elements.closeButton.addEventListener('click', event => this._closeDownloads(event), false);
        this._elements.modalCloseButton && this._elements.modalCloseButton.addEventListener('click', event => this._closeDownloads(event), false);
    }

    /**
     * Open downloads window
     *
     * @private
     * @param {event} event
     */
    _openDownloads(event) {
        this._state.isDownloading = true;
        this._elements.body.setAttribute('data-downloading', this._state.isDownloading);
        const link = event.target.getAttribute('href');
        this._elements.statusLink.setAttribute('href', link);
    }

    /**
     * Close downloads window
     *
     * @private
     * @param {event} event
     */
    _closeDownloads(event) {
        event.preventDefault();
        this._state.isDownloading = false;
        this._elements.body.setAttribute('data-downloading', this._state.isDownloading);
        this._elements.statusLink.setAttribute('href', '');
    }
}

export default Downloads;

/* eslint-enable */

